import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

export default function initHome() {

	const slider = document.querySelector('.home__hero .swiper');

	const swiper = new Swiper(slider, {
		modules: [Navigation, Autoplay, Pagination],
    slidesPerView: 1,
    simulateTouch: false,
    speed: 1000,
    loop: true,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    // pagination
	  pagination: {
	    el: document.querySelector('.home__hero .swiper-pagination'),
	    type: 'bullets',
	  },
      // Navigation arrows
      navigation: {
        nextEl: document.querySelector('.home__hero .swiper-button-next'),
        prevEl: document.querySelector('.home__hero .swiper-button-prev'),
      },
  });

  if(document.querySelectorAll('.home__hero  .home__hero__content').length == 1) {
    document.querySelector('.home__hero .swiper-pagination').style.display = 'none';
    document.querySelector('.home__hero .nav').style.display = 'none';
  }


}